// extracted by mini-css-extract-plugin
export default {"divider":"pn4ZEhg2GbKj0w9JxlSb","borderDivider":"U6Zbe57cBrGarpDmZDOl"};